module.exports = __webpack_public_path__ + "static/media/3.229442de.jpg";